import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { extractReferralFromUrl } from '../utils/referralHelper';
import { PATHS } from '../constants/paths';

const ReferralRedirectPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Извлекаем и сохраняем referral ID
    extractReferralFromUrl(location);

    // Перенаправляем на главную страницу
    navigate(PATHS.HOME.PATH, { replace: true });
  }, [location, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px'
    }}>
      Загрузка...
    </div>
  );
};

export default ReferralRedirectPage;
